import { render } from "./DreamWaterPage.vue?vue&type=template&id=0bdfa902&scoped=true"
import script from "./DreamWaterPage.vue?vue&type=script&lang=js"
export * from "./DreamWaterPage.vue?vue&type=script&lang=js"

import "@/assets/css/cases.css?vue&type=style&index=0&id=0bdfa902&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdfa902"]])

export default __exports__